<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="itemPackagesField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeItemPackagesField] ? 'Exclude' : 'Include')} Item Packages`"
      :options="itemPackages.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      bottom-slots
      :rules="[
        val => !!val || 'Field is required'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeItemPackagesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'ItemPackagesConditionForm',
  configuration: ['itemPackages'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    itemPackagesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.ITEM_PACKAGES
    },
    excludeItemPackagesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_ITEM_PACKAGES
    }
  }
}

</script>
